export class CompanyStateChange {
    constructor() {
        this.companyId;
        this.companyState;
        this.note;
        this.userId;
        this.techAssessmentLimitForSoftHold;
        // this.jbiLimitForSoftHold;
    }
}
//# sourceMappingURL=change-company-state.model.js.map